import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PatientTable from "../components/patientTable";
import SeriviceTable from "../components/serviceTable";
import AppLayout from "../components/AppLayout";
import StaffTable from "../components/staffTable";
import {
  getBusinessAppointment,
  getBusinessPatients,
  getBusinessDetails,
  getBusinessFields,
  getBusinessServices,
  getBusinessStaff,
  getBusinessDocuments,
  editBusiness,
  editBusinessServices,
  getBusiness
} from "../logic/business/action";
import { MdClose, MdDelete, MdEdit } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { Form, Formik, Field } from "formik";
import AppointmentTable from "../components/appointmentTable";
import DocumentTable from "../components/documentTable";
import FieldsTable from "../components/fieldsTable";
import Header from "../components/header";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { DELETE_BUSINESS } from "../utils/urls";
import { deleteData } from "../utils/serverHelper";
import { errorMessage } from "../logic/error/action";
// import { getBusinessDocument } from "../../../controllers/business.controller";

const BusinessDetails = () => {
  const dispatch = useDispatch();
  const [state, setState] = useState(0);
  const [stateForm, setStateForm] = useState({
    name:'',
    role:'',
    email:'',
    contact:'',
  });
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(0);
  const [editModeIndi, setEditModeIndi] = useState(false);
  const [editModeIndiValue, setEditModeIndiValue] = useState('');
  const [editModeIndiLabel, setEditModeIndiLabel] = useState('');
  const selectorAuth = useSelector(state=>state.auth);

  const formPopUp = useRef();

  useEffect(() => {
    const clickOutsideHandler = (e) => {
      if (!formPopUp.current?.contains(e.target)) {
        setEditMode(false);

        // openHam;
      }
    };
    document.addEventListener("mousedown", clickOutsideHandler);

    return () => {
      document.removeEventListener("mousedown", clickOutsideHandler);
    };
  }, []);
  const params = useParams();
  const selector = useSelector((state) => state.business);
  useEffect(() => {
    setState(0);
    getBusinessDetails(dispatch, params.id);
  }, []);
  // console.log(selector, "all data");



  const getTables = async (id) => {
    setState(id);
    if (id === 0) {
      getBusinessServices(dispatch, params.id);
    } else if (id === 1) {
      getBusinessStaff(dispatch, params.id);
    } else if (id === 2) {
      getBusinessPatients(dispatch, params.id);
    
    } else if (id === 3) {
      getBusinessAppointment(dispatch, params.id);
    
    } else if (id === 4) {
      getBusinessDocuments(dispatch, params.id);
    
    } else if (id === 5) {
      getBusinessFields(dispatch, params.id);
    }
  };

  const initialValues = {
    name: "",
  };

  // console.log(
  //   "guys data here",
  //   selector?.staff.filter((staffData) => staffData.staff_id === 41)
  // );

  const formSubmit = (values) => console.log(values);
  const [deleteBusiness, setDeleteBusiness] = useState(0);
  const nav = useNavigate();
  // const params = useParams();

  const deleteBusinessFunc = async() => {
    try {
      // if(deleteBusiness !== 0){
        await deleteData(DELETE_BUSINESS(params.id));
        // await getBusiness(dispatch);
        nav(-1);
        setDeleteBusiness(false);
      // }
    } catch (error) {
      console.log(error);
      setDeleteBusiness(false);
      errorMessage(dispatch,error.response?.data?.error?.message)
      // toast.error( error.response?.data?.error?.message || 'Something went wrong for deleting business' );
    }
  }



  return (
    <>
      <div
        className={`h-screen w-screen bg-black/60 absolute z-50 ${
          editMode ? "flex items-center justify-center" : "hidden"
        } `}
      >
        <div className="bg-white p-8 relative flex flex-col gap-2" ref={formPopUp}>
          <span
            className="absolute top-2 right-2 cursor-pointer"
            onClick={() => setEditMode((prev) => !prev)}
          >
            <RxCross2 size={24} />
          </span>
          <h4 className="font-bold text-xl text-blue-800 text-center ">
            {state === 0 && "Edit Service"}
            {state === 1 && "Edit Staff Details"}
            {state === 2 && "Edit Patients Details"}
            {state === 3 && "Edit Appointment"}
            {state === 4 && "Edit Document"}
            {state === 5 && "Edit Field"}
            {state === 6 && "Edit Limit"}
          </h4>
          
                  {
                    state === 1 || state === 2 ? 
                  <>
                  <div>
                    <label htmlFor="name">Name</label>
                     {
                      state === 2 ?
                      <input type="text" name="full_name" value={stateForm.full_name} onChange={(e)=>setStateForm(prev=>({...prev,[e.target.name]:e.target.value}))}/>
                      : 
                     <input type="text" name="name" value={stateForm.name} onChange={(e)=>setStateForm(prev=>({...prev,[e.target.name]:e.target.value}))}/>
                     }
                  </div>
                  {/* <div>
                    <label htmlFor="name">Email</label>
                    <input type="text" name="email" value={stateForm.email} onChange={(e)=>setStateForm(prev=>({...prev,[e.target.name]:e.target.value}))}/>
                  </div> */}
                  <div>
                    <label htmlFor="name">Contact</label>
                    <input type="text" name="contact" value={stateForm.contact} onChange={(e)=>setStateForm(prev=>({...prev,[e.target.name]:e.target.value}))}/>
                  </div>
                  </>  
                    :''
                  }
                  {
                    state === 3 && (
                      <>
                  <div>
                    <label htmlFor="start_date">Start Date</label>
                    <input type="date" name="start_date" value={stateForm.start_date} onChange={(e)=>setStateForm(prev=>({...prev,[e.target.name]:e.target.value}))}/>
                  </div>
                  <div>
                    <label htmlFor="start_time">Start Time</label>
                    <input type="time" name="start_time" value={stateForm.start_time} onChange={(e)=>setStateForm(prev=>({...prev,[e.target.name]:e.target.value}))}/>
                  </div>
                  <div>
                    <label htmlFor="reason">Reason</label>
                    <input type="text" name="reason" value={stateForm.reason} onChange={(e)=>setStateForm(prev=>({...prev,[e.target.name]:e.target.value}))}/>
                  </div>
                  <div>
                    <label htmlFor="staff">Staff</label>
                    <select type="text" name="staff_id" value={stateForm.staff_id} onChange={(e)=>setStateForm(prev=>({...prev,[e.target.name]:e.target.value}))}>
                      <option value="">Select Staff</option>
                      {
                        selector.staff.map(
                          (elem,i)=><option value={elem.staff_id} key={i}>
                            {elem.name}
                          </option>
                        )
                      }
                    </select>
                  </div>
                      
                      </>
                    )
                  }
                  {state === 1 && (
                    <div>
                      <label htmlFor="role">Role</label>
                      <select name="role" id="role" value={stateForm.role} onChange={(e)=>setStateForm(prev=>({...prev,[e.target.name]:e.target.value}))}>
                        <option value="">Select Role</option>
                        <option value="Admin">Admin</option>
                        <option value="Doctor">Doctor</option>
                      </select>
                      {/* <label htmlFor="name">Role</label>
                      <Field type="text" name="role" /> */}
                    </div>
                  )}

                  {state === 0 && (
                    <div className="gap-4 flex flex-col">
                      <label htmlFor="service">Services</label>
                      <input type="text" name="service" placeholder="Service" value={stateForm.service} onChange={(e)=>setStateForm(prev=>({...prev,[e.target.name]:e.target.value}))}/>
                      <label htmlFor="charges">Charges</label>
                      <input type="text" name="charges" placeholder="charges" value={stateForm.charges} onChange={(e)=>setStateForm(prev=>({...prev,[e.target.name]:e.target.value}))}/>
                    </div>
                  )}
{/* <button>Save</button> */}
                  <button 
                  // type="button"
                  onClick={()=>{
                    editBusinessServices(dispatch,editId,params.id,[
                      {
                        label:'service',
                        value:stateForm.service
                      },
                      {
                        label:'charges',
                        value:stateForm.charges
                      }
                    ])
                    setEditMode(false)
                  }}
                  // className="self-center"
                  >Save Changes</button>
        </div>
      </div>

      <div className={`w-screen h-screen bg-black/60 ${editModeIndi?'flex':'hidden'} items-center justify-center`}>
            <div className="flex items-center p-10 gap-10 bg-white relative">
              <div className="absolute top-4 right-4" onClick={()=>setEditModeIndi(false)}><MdClose/></div>
              <input value={editModeIndiValue} onChange={(ev)=>setEditModeIndiValue(ev.target.value)} type="text" placeholder="value"/>
              <button
              onClick={()=>{
                editBusiness(dispatch,params.id,{label:editModeIndiLabel,value:editModeIndiValue});
                setEditModeIndi(false);
              }}
              >Edit</button>
            </div>
      </div>
      
      <Dialog open={deleteBusiness}>
          <DialogTitle>Are you sure you want delete business?</DialogTitle>
          <DialogContent>It will delete all data related to business permanently</DialogContent>
          <DialogActions>
            <Button onClick={()=>setDeleteBusiness(false)}>cancel</Button>
            <Button onClick={
              deleteBusinessFunc
            } variant="contained" color="error">delete</Button>
          </DialogActions>
        </Dialog>
      <AppLayout>
        <div className="w-full h-full flex flex-col items-start gap-4 p-4">
          <Header 
          title={'Business Details'}
          actions={<>
          <IconButton onClick={()=>{
            setDeleteBusiness(true);
          }}>
            <MdDelete color="red"/>
          </IconButton>
          </>}
          />
          <div className="w-full flex items-start px-10">
          <div className="flex flex-col gap-4 flex-1">
          <h1 className="flex items-center gap-2">
            <span> Name - {selector?.details?.name}</span> <MdEdit onClick={()=>{
              setEditModeIndiLabel('name');
              setEditModeIndiValue(selector?.details?.name);
              setEditModeIndi(true);
            }} />
          </h1>
          <h1 className="flex items-center gap-2">
            <span> Credit - ₹{parseFloat(selector?.details?.credit).toFixed(2)}</span> <MdEdit onClick={()=>{
              setEditModeIndiLabel('credit');
              setEditModeIndiValue(parseFloat(selector?.details?.credit).toFixed(2));
              setEditModeIndi(true);
            }} />
          </h1>
          <h1 className="flex items-center gap-2">
            <span> Owner - {selector?.details?.owner}</span> <MdEdit onClick={()=>{
              setEditModeIndiLabel('owner');
              setEditModeIndiValue(selector?.details?.owner);
              setEditModeIndi(true);
            }} />
          </h1>
          <p className="flex items-center gap-2">
            <span> Email - {selector?.details?.email}</span> 
            {/* <MdEdit onClick={()=>{
              // setEditModeIndi(true);
            }} /> */}
          </p>
          <p className="flex items-center gap-2">
            <span> Phone - +91 {selector?.details?.contact} </span>
            <MdEdit onClick={()=>{
              setEditModeIndiLabel('contact');
              setEditModeIndiValue(selector?.details?.contact);
              setEditModeIndi(true);
            }} />
          </p>
          <p className="flex items-center gap-2">
            <span> Address - {selector?.details?.address} </span>
            <MdEdit onClick={()=>{
              setEditModeIndiLabel('address');
              setEditModeIndiValue(selector?.details?.address);
              setEditModeIndi(true);
            }} />
          </p>
          </div>
          <div className="flex flex-col gap-4 flex-1">
          <p className="flex items-center gap-2">
            <span> Storage Limit - {selector?.details?.storage_limit} </span>
            <MdEdit onClick={()=>{
              setEditModeIndiLabel('address');
              setEditModeIndiValue(selector?.details?.address);
              setEditModeIndi(true);
            }} />
          </p>
          <p className="flex items-center gap-2">
            <span> SMS Limit - {selector?.details?.sms_limit} </span>
            <MdEdit onClick={()=>{
              setEditModeIndiLabel('address');
              setEditModeIndiValue(selector?.details?.address);
              setEditModeIndi(true);
            }} />
          </p>
          <p className="flex items-center gap-2">
            <span> Staff Limit - {selector?.details?.staff_limit} </span>
            <MdEdit onClick={()=>{
              setEditModeIndiLabel('address');
              setEditModeIndiValue(selector?.details?.address);
              setEditModeIndi(true);
            }} />
          </p>
          <p className="flex items-center gap-2">
            <span> Patient Limit - {selector?.details?.patient_limit || selector?.details?.customer_limit} </span>
            <MdEdit onClick={()=>{
              setEditModeIndiLabel('address');
              setEditModeIndiValue(selector?.details?.address);
              setEditModeIndi(true);
            }} />
          </p>
          <p className="flex items-center gap-2">
            <span> Appointment Limit - {selector?.details?.appointment_limit} </span>
            <MdEdit onClick={()=>{
              setEditModeIndiLabel('address');
              setEditModeIndiValue(selector?.details?.address);
              setEditModeIndi(true);
            }} />
          </p>
          <p className="flex items-center gap-2">
            <span> Service Limit - {selector?.details?.service_limit} </span>
            <MdEdit onClick={()=>{
              setEditModeIndiLabel('address');
              setEditModeIndiValue(selector?.details?.address);
              setEditModeIndi(true);
            }} />
          </p>
          </div>
            </div>
          {
            selectorAuth?.user?.role === 'super_admin'?
          <div className="flex items-center flex-wrap bg-slate-200 w-full h-auto">
            <p
              onClick={() => getTables(0)}
              className={`cursor-pointer flex-1 text-center ${
                state === 0 ? "bg-slate-500" : ""
              }  h-full flex items-center justify-center`}
            >
              Services
            </p>
            <p
              onClick={() => getTables(1)}
              className={`cursor-pointer ${
                state === 1 ? "bg-slate-500" : ""
              } flex-1 text-center h-full flex items-center justify-center`}
            >
              Staff
            </p>
            <p
              onClick={() => getTables(2)}
              className={`cursor-pointer ${
                state === 2 ? "bg-slate-500" : ""
              } flex-1 text-center h-full flex items-center justify-center`}
            >
              Patients
            </p>
            <p
              onClick={() => getTables(3)}
              className={`cursor-pointer ${
                state === 3 ? "bg-slate-500" : ""
              } flex-1 text-center h-full flex items-center justify-center`}
            >
              Appointments
            </p>
            <p
              onClick={() => getTables(4)}
              className={`cursor-pointer ${
                state === 4 ? "bg-slate-500" : ""
              } flex-1 text-center h-full flex items-center justify-center`}
            >
              Documents
            </p>
            <p
              onClick={() => getTables(5)}
              className={`cursor-pointer ${
                state === 5 ? "bg-slate-500" : ""
              } flex-1 text-center h-full flex items-center justify-center`}
            >
              Fields
            </p>
          </div>
          :''
        }
          {selectorAuth?.user?.role === 'super_admin'?state === 0 ? (
            <SeriviceTable setEditMode={(data) => {
              setStateForm({...data})
              setEditMode((prev) => !prev)
              setEditId(data?.service_id);
            }
            } />
          ) : state === 1 ? (
            <StaffTable setEditMode={(data) => 
              {
                setStateForm({...data});
                setEditMode((prev) => !prev)
              }
            
            } />
          ) : state === 2 ? (
            <PatientTable setEditMode={(data) => {
              setStateForm({...data})
              setEditMode((prev) => !prev)
            }
          } />
          ) : state === 3 ? (
            <AppointmentTable setEditMode={(data) => {
              setStateForm({...data})
              setEditMode((prev) => !prev)
            }
          } />
          ) : state === 4 ? (
            <DocumentTable setEditMode={(data) => {
              setStateForm({...data})
              setEditMode((prev) => !prev)
            }
          } />
          ) : state === 5 ? (
            <FieldsTable setEditMode={(data) => {
              setStateForm({...data})
              setEditMode((prev) => !prev)
            }
          } />
          ) : (
            <PatientTable />
          ):''}
        </div>
    </AppLayout>
    </>
  );
};

export default BusinessDetails;
